import request from '@/utils/zsm-requets'
var shipinhao = '/zsm/api/shipinhao/'




/**
 * 公众号文章列表
 */
export function shipinhaoArticleList(params) {
  return request({
    url: shipinhao + 'articleList',
    method: 'post',
    params
  })
}


/**
 * 公众号文章列表(单个)
 * params id 文章编号
 */
export function shipinhaoArticleView(params) {
  return request({
    url: shipinhao + 'articleView',
    method: 'post',
    params
  })
}
